import { useMutation, useQueryClient } from '@tanstack/react-query';
import { IUpdateMenuSetRequest, IUpdateMenuSetResponseBody, updateMenuSet } from 'src/api/updateMenuSet';
import { useUserTracking } from '../useUserTracking/useUserTracking';
import { QueryKeys } from '../QueryKeys';

export const useUpdateMenuSet = (menuSetId: string) => {
  const queryClient = useQueryClient();
  const { trackEvent, captureException } = useUserTracking();

  return useMutation<IUpdateMenuSetResponseBody, Error, IUpdateMenuSetRequest>(
    (payload) => updateMenuSet(menuSetId, payload),
    {
      onSuccess: async ({ data: [menuSet] }, { menu_labels }) => {
        trackEvent('menu_set_updated', { menuSetName: menuSet.name, menuCount: menuSet.menus.length });
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: [QueryKeys.menuSet] }),
          queryClient.invalidateQueries({ queryKey: [QueryKeys.menuSets] }),
          menu_labels && queryClient.invalidateQueries({ queryKey: [QueryKeys.menuLabels] }),
        ]);
      },
      onError: (error) => {
        captureException(error, { tags: { action: 'menu_set_update', menuSetId } });
      },
    },
  );
};
